const { getUserData } = require("./getUserData.js");

export const loadTeacherData = async (currentUser, setMyCoreCourses) => {
  if (currentUser.roles.includes("Teacher")) {
    const teacherCoreCourses = await getUserData("coreCourse", currentUser);
    setMyCoreCourses(teacherCoreCourses);
  }
};
